import React, { useState, useEffect } from 'react';
import { Modal } from 'antd';
import classnames from 'classnames';
import { apiHolder as api, apis } from 'api';
import CloseIcon from '@web-common/components/UI/Icons/svgs/CloseMailSvg';
import styles from './praiseMail.module.scss';
import { getIn18Text } from 'api';
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const MedalChooser = ({ visible, chosenMedal, chooseMedal, onCancel }) => {
    const [medals, setMedals] = useState([]);
    useEffect(() => {
        mailApi.doGetPraiseMedals().then(setMedals);
    }, []);
    const select = (medalId) => {
        chooseMedal(medalId);
    };
    return (React.createElement(Modal, { title: null, closable: false, width: 522, wrapClassName: "medal-chooser", visible: visible, onCancel: onCancel, footer: null, getContainer: () => document.body },
        React.createElement("div", { className: styles.medalBox },
            React.createElement("div", { className: styles.header },
                React.createElement("div", { className: styles.title }, getIn18Text('XUANZEXUNZHANG')),
                React.createElement("div", { className: styles.closeButton, onClick: onCancel },
                    React.createElement(CloseIcon, null)),
                React.createElement("div", { className: styles.desc }, getIn18Text('LAJINWOMENZHI'))),
            React.createElement("div", { className: styles.medalList }, medals.map(medal => (React.createElement("div", { className: classnames([styles.medalItem], {
                    [styles.selected]: (chosenMedal === null || chosenMedal === void 0 ? void 0 : chosenMedal.id) === medal.id,
                }), key: medal.name, onClick: () => select(medal.id) },
                React.createElement("div", { className: styles.medalImg },
                    React.createElement("img", { alt: medal.name, src: medal.imageUrl })),
                React.createElement("div", { className: styles.medalInfo },
                    React.createElement("div", { className: styles.medalName }, medal.name),
                    React.createElement("div", { className: styles.medalDesc }, medal.description)))))))));
};
export default MedalChooser;
